/* unplugin-vue-components disabled */import script from "./business-segment.vue?vue&type=script&setup=true&lang=ts"
export * from "./business-segment.vue?vue&type=script&setup=true&lang=ts"

import "./business-segment.vue?vue&type=style&index=0&id=2e5874e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5874e8"]])

export default __exports__